<script setup lang="ts">
import router from '@/routes'
import { useWorkspaceStore } from '@/store/workspace'
import { computed } from 'vue'
import { Avatar, Icon, Menu, MenuItem, MenuTitle } from '../common'

const workspaceStore = useWorkspaceStore()

const otherWorkspaces = computed(() =>
  workspaceStore.workspaces.filter(
    (w) => w.id !== workspaceStore.workspace?.id,
  ),
)
function createNewWorkspace(){
  router.push({name:"Onboarding"})
}
</script>
<template>
  <Menu :width="272">
    <MenuTitle>Current Workspace</MenuTitle>
    <router-link
      v-slot="{ navigate }"
      custom
      :to="{ name: 'WorkspaceSettings' }"
    >
      <MenuItem
        :hide-on-click="true"
        :title="workspaceStore.workspace?.title || ''"
        @click="navigate"
      >
        <template #icon>
          <Avatar
            v-if="workspaceStore.workspace?.logo"
            :src="workspaceStore.workspace?.logo"
            :size="24"
          />
          <div v-else :class="$style.workspaceLogo">
            <Icon icon="block" :size="16" />
          </div>
        </template>
        <template #action>
          <Icon :size="20" icon="settingsGear2" :class="$style.icon" />
        </template>
      </MenuItem>
    </router-link>
    <template v-if="otherWorkspaces.length > 0">
      <hr />
      <MenuTitle>Other Workspaces</MenuTitle>
      <router-link
        v-for="workspace in otherWorkspaces"
        :key="workspace.id"
        v-slot="{ href }"
        custom
        :to="{ name: 'Dashboard', params: { workspaceId: workspace.id } }"
      >
        <a :href="href">
          <MenuItem :title="workspace.title || ''">
            <template #icon>
              <Avatar v-if="workspace.logo" :src="workspace.logo" :size="24" />
              <div v-else :class="$style.workspaceLogo">
                <Icon icon="block" :size="16" />
              </div>
            </template>
          </MenuItem>
        </a>
      </router-link>
    </template>
    <MenuItem title="Create new workspace" @click="createNewWorkspace"><template #icon><Icon icon="plusSmall" :size="20"/></template></MenuItem> 
  </Menu>
</template>
<style module lang="scss">
.icon {
  color: var(--neutral-11);
}
.workspaceLogo {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--neutral-3);
  color: var(--neutral-8);
}
</style>
